import React from "react";
import image from "../images/logo.webp";
import { AiOutlineHome, AiOutlinePhone, AiOutlineMail } from "react-icons/ai";
import { Link } from "react-router-dom";

const quickLinks = [
  { name: "Home", to: "/" },
  { name: "About", to: "/about" },
  { name: "Products", to: "/products" },
  { name: "Gallery", to: "/gallery" },
  { name: "Contact", to: "/contact" },
];

const Footer = () => {
  return (
    <footer className="bg-[#071626] text-slate-100 text-sm border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* 1. Company Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img src={image} alt="Dynamic Exim" className="h-14 w-auto brightness-110" />
            </Link>
            <p className="font-bold text-white text-base leading-snug">
              THE DYNAMIC EXPORT IMPORT LTD.
            </p>
            <p className="text-slate-200 text-sm leading-relaxed">
              Providing reliable elastic since 2017
            </p>
            <div className="pt-2">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-xs font-semibold text-slate-200 border border-white/15">
                <span className="w-2 h-2 rounded-full bg-[#EB4438] animate-pulse"></span>
                Global Export Partner
              </span>
            </div>
          </div>

          {/* 2. Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider pb-1 border-b border-slate-700/60 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-slate-200 hover:text-white hover:translate-x-1 transition-all duration-200 inline-flex items-center gap-2 font-medium"
                  >
                    <span className="text-[#EB4438] font-bold">&rsaquo;</span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. Office Location */}
          <div className="space-y-4">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider pb-1 border-b border-slate-700/60 inline-block">
              Our Office
            </h4>
            <div className="flex items-start gap-3.5">
              <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center text-[#EB4438] shrink-0 mt-0.5">
                <AiOutlineHome className="text-xl" />
              </div>
              <div className="space-y-1">
                <p className="text-white font-semibold text-xs uppercase tracking-wider">Address</p>
                <p className="text-slate-200 text-sm leading-relaxed font-normal">
                  House #874/D (Ground Floor)<br />Master para, Uttarkhan, Dhaka-1230
                </p>
              </div>
            </div>
          </div>

          {/* 4. Contact Details (Phone & Email) */}
          <div className="space-y-4">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider pb-1 border-b border-slate-700/60 inline-block">
              Get in Touch
            </h4>

            {/* Phone */}
            <div className="flex items-start gap-3.5">
              <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center text-[#EB4438] shrink-0 mt-0.5">
                <AiOutlinePhone className="text-xl" />
              </div>
              <div className="space-y-1">
                <p className="text-white font-semibold text-xs uppercase tracking-wider">Phone</p>
                <p>
                  <a href="tel:01941422183" className="text-slate-200 hover:text-white font-medium text-sm block transition-colors">
                    01941422183
                  </a>
                  <a href="tel:01924107356" className="text-slate-200 hover:text-white font-medium text-sm block transition-colors">
                    01924107356
                  </a>
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-3.5 pt-1">
              <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center text-[#EB4438] shrink-0 mt-0.5">
                <AiOutlineMail className="text-xl" />
              </div>
              <div className="space-y-1">
                <p className="text-white font-semibold text-xs uppercase tracking-wider">Email</p>
                <a
                  href="mailto:moin_dynamic201718@yahoo.com"
                  className="text-slate-200 hover:text-white font-medium text-sm block transition-colors break-all"
                >
                  moin_dynamic201718@yahoo.com
                </a>
                <a
                  href="mailto:moin@dynamic-exim.com"
                  className="text-slate-200 hover:text-white font-medium text-sm block transition-colors break-all"
                >
                  moin@dynamic-exim.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-300">
          <p className="font-medium text-slate-300">Copyright © 2024 - All right reserved</p>
          <p className="text-slate-300 font-medium">Premium Elastic Manufacturing & Export Solutions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
